import LangContext from './LangContext';

export default LangContext;
